/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
// import Tooltip from '@material-ui/core/Tooltip';

import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import { MuiThemeProvider } from '@material-ui/core/styles';
import { Tooltip } from '../../Components/Tooltip';

import { theme } from '../../Theme/theme';

export const columns = (handleOnClick, strings) => {
  const uid = 'code';
  // TODO: https://github.com/bvaughn/react-virtualized/blob/master/source/CellMeasurer/CellMeasurer.DynamicHeightTableColumn.example.js#L70-L94
  // eslint-disable-next-line
  const PersonColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    // eslint-disable-next-line no-underscore-dangle
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

    return cellData ? (
      <Tooltip title={strings['parties.grid.column.category.natural.label'] || 'Natural Person'} placement="left">
        <Icon className="icon-person natural">person</Icon>
      </Tooltip>
    ) : (
      <Tooltip title={strings['parties.grid.column.category.legal.label'] || 'Legal Person'} placement="left">
        <Icon className="icon-person legal">domain</Icon>
      </Tooltip>
    );
  };

  // eslint-disable-next-line
  const ActiveColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    // eslint-disable-next-line no-underscore-dangle
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

    return cellData === 'yes' ? (
      <Tooltip title={strings['parties.grid.column.status.active.label'] || 'Active'} placement="left">
        <Icon className="icon-status yes">check_circle</Icon>
      </Tooltip>
    ) : (
      <Tooltip title={strings['parties.grid.column.status.inactive.label'] || 'Inactive'} placement="left">
        <Icon className="icon-status no">cancel</Icon>
      </Tooltip>
    );
  };
  ActiveColumnCellRenderer.propTypes = {
    rowData: PropTypes.any,
    cellData: PropTypes.any,
  };

  // eslint-disable-next-line
  const ActionsColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    const getIcon = action => {
      switch (action.get('action')) {
        case 'modify':
          return <EditIcon fontSize="small" />;
        case 'cancel':
          return <DeleteIcon fontSize="small" />;
        case 'view':
          return <RemoveRedEyeIcon fontSize="small" />;
        case 'link':
          return <OpenInNewIcon fontSize="small" />;

        default:
          return strings[action.get('label')];
      }
    };
    const getColor = action => {
      switch (action.get('action')) {
        case 'modify':
          return 'primary';
        case 'cancel':
          return 'secondary';
        case 'view':
          return 'primary';
        case 'link':
          return 'primary';

        default:
          return 'primary';
      }
    };
    const actions = [];
    try {
      cellData.forEach(action => {
        if (action.get('type') === 'action') {
          actions.push(
            <Tooltip key={`tooltip-${rowData.get(uid)}`} title={strings[action.get('label')]} placement="left">
              <IconButton
                title={strings[action.get('label')]}
                size="small"
                key={`${action.get('route')}-${rowData.get(uid)}`}
                label={strings[action.get('label')]}
                aria-label={strings[action.get('label')]}
                color={getColor(action)}
                className={getColor(action)}
                onClick={() =>
                  handleOnClick({
                    route: action.get('route'),
                    type: action.get('type'),
                    action: action.get('action'),
                    id: rowData.get(uid),
                  })
                }
                onTouchEnd={() =>
                  handleOnClick({
                    route: action.get('route'),
                    type: action.get('type'),
                    id: rowData.get(uid),
                  })
                }
              >
                {/* {strings[action.get('label')]} */}
                {getIcon(action)}
              </IconButton>
            </Tooltip>
          );
        } else {
          const route = `${action.get('route')}${rowData.get(uid)}`;
          const link = props => <Link to={route} {...props} />;
          actions.push(
            <Tooltip key={`tooltip-${rowData.get(uid)}`} title={strings[action.get('label')]} placement="left">
              <IconButton
                // title={strings[action.get('label')]}
                component={React.forwardRef((props, ref) => link(props))}
                size="small"
                key={`${action.get('route')}-${rowData.get(uid)}`}
                label={strings[action.get('label')]}
                aria-label={strings[action.get('label')]}
                color={getColor(action)}
                className={getColor(action)}
              >
                {getIcon(action)}
              </IconButton>
            </Tooltip>
          );
        }
      });
    } catch (e) {
      actions.push(`Invalid link: ${e}`);
    }

    return (
      <>
        <MuiThemeProvider theme={theme}>{actions}</MuiThemeProvider>
      </>
    );
  };
  ActionsColumnCellRenderer.propTypes = {
    rowData: PropTypes.any,
    cellData: PropTypes.any,
  };

  return [
    {
      name: 'code',
      label: strings['parties.grid.column.code.label'] || 'Code',
      width: 40,
    },
    {
      name: 'fullName',
      label: strings['parties.grid.column.fullName.label'] || 'Full Name',
      width: 180,
    },
    {
      name: 'isPerson',
      label: strings['parties.grid.column.isPerson.label'] || 'Category',
      width: 40,
      type: 'rendered',
      render: PersonColumnCellRenderer,
    },
    {
      name: 'active',
      label: strings['parties.grid.column.active.label'] || 'active',
      width: 40,
      type: 'rendered',
      render: ActiveColumnCellRenderer,
    },
    {
      name: 'actions',
      label: strings['parties.grid.column.actions.label'] || 'Actions',
      width: 40,
      type: 'rendered',
      render: ActionsColumnCellRenderer,
    },
  ];
};

// ================
// FILTERS UI
// ================
export const filtersUI = ({ strings }) => ({
  query: {
    value: '',
    label: strings['parties.filter.query.label'] || 'Filter by Id or Subscriber',
    placeholder: strings['parties.filter.query.placeholder'] || 'eg. Paul Smith or 34G78... ',
    type: 'text',
    name: 'query',
  },
  person: {
    value: [],
    options: [
      {
        label: strings['parties.grid.column.category.legal.label'] || 'Legal Person',
        value: 'legal',
      },
      {
        label: strings['parties.grid.column.category.natural.label'] || 'Natural Person',
        value: 'natural',
      },
    ],
    label: strings['parties.filter.category.label'] || 'Filter by Category',
    name: 'person',
    type: 'checkbox',
  },
  active: {
    value: [],
    options: [
      {
        label: strings['parties.grid.column.status.inactive.label'] || 'Inactive',
        value: 'no',
      },
      {
        label: strings['parties.grid.column.status.active.label'] || 'Active',
        value: 'yes',
      },
    ],
    label: strings['parties.filter.status.label'] || 'Filter by Status',
    name: 'active',
    type: 'checkbox',
  },
});
